import React, { useState, useCallback, useEffect } from 'react';
import { getAllCaterings } from '../../../services/OrderService';
import CateringHistoryList from '../../components/OrderHistory/CateringHistoryList';

const CateringHistory = () => {
    const [cateringData, setCateringData] = useState({
        data: [],
        current_page: 1,
        total_pages: 1
    });
    const [pageItems, setPageItems] = useState(10);
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [isInitialized, setIsInitialized] = useState(false);

    const getCaterings = useCallback((page = 1, itemsPerPage = pageItems) => {
        getAllCaterings(page, itemsPerPage, fromDate, toDate)
            .then(response => {
                if (response) {
                    // Handle different response structures
                    let data, totalPages, currentPage;
                    
                    if (Array.isArray(response)) {
                        // If response is directly an array (your current structure)
                        data = response;
                        totalPages = Math.ceil(response.length / itemsPerPage);
                        currentPage = page;
                    } else if (response.data) {
                        // If response has data property (API pagination structure)
                        data = Array.isArray(response.data) ? response.data : [];
                        totalPages = response.total_pages || Math.ceil(data.length / itemsPerPage);
                        currentPage = response.current_page || page;
                    } else {
                        data = [];
                        totalPages = 1;
                        currentPage = 1;
                    }

                    // Sort data by ID
                    data.sort((a, b) => (a.id > b.id) ? 1 : ((b.id > a.id) ? -1 : 0));

                    setCateringData({
                        data: data,
                        current_page: currentPage,
                        total_pages: totalPages
                    });
                } else {
                    // Handle empty or invalid response
                    setCateringData({
                        data: [],
                        current_page: 1,
                        total_pages: 1
                    });
                }
                setPageItems(itemsPerPage);
            })
            .catch(error => {
                console.error("Error fetching caterings:", error);
                // Set empty data on error
                setCateringData({
                    data: [],
                    current_page: 1,
                    total_pages: 1
                });
            });
    }, [fromDate, toDate, pageItems]);

    const handlePageChange = (page) => {
        getCaterings(page, pageItems);
    };

    const handlePageItemsChange = (items) => {
        setPageItems(items);
        getCaterings(1, items);
    };

    const handleDateFilter = (from, to) => {
        // Update state first
        setFromDate(from);
        setToDate(to);
        
        // Then fetch data with the updated filters
        // Use the parameters directly rather than state variables
        // since state updates are asynchronous
        getAllCaterings(1, pageItems, from, to)
            .then(response => {
                if (response) {
                    let data, totalPages;
                    
                    if (Array.isArray(response)) {
                        data = response;
                        totalPages = Math.ceil(response.length / pageItems);
                    } else if (response.data) {
                        data = Array.isArray(response.data) ? response.data : [];
                        totalPages = response.total_pages || Math.ceil(data.length / pageItems);
                    } else {
                        data = [];
                        totalPages = 1;
                    }

                    // Sort data by ID
                    data.sort((a, b) => (a.id > b.id) ? 1 : ((b.id > a.id) ? -1 : 0));

                    setCateringData({
                        data: data,
                        current_page: 1,
                        total_pages: totalPages
                    });
                } else {
                    setCateringData({
                        data: [],
                        current_page: 1,
                        total_pages: 1
                    });
                }
            })
            .catch(error => {
                console.error("Error filtering caterings:", error);
                setCateringData({
                    data: [],
                    current_page: 1,
                    total_pages: 1
                });
            });
    };
    
    // Initialize component with data on first render
    useEffect(() => {
        if (!isInitialized) {
            getCaterings(1, pageItems);
            setIsInitialized(true);
        }
    }, [getCaterings, isInitialized, pageItems]);

    return (
        <CateringHistoryList 
            cateringList={cateringData.data}
            getCaterings={getCaterings}
            pagination={{
                currentPage: cateringData.current_page,
                totalPages: cateringData.total_pages
            }}
            pageItems={pageItems}
            onPageChange={handlePageChange}
            onPageItemsChange={handlePageItemsChange}
            onDateFilter={handleDateFilter}
        />
    );
}

export default CateringHistory;